import { render, staticRenderFns } from "./Personalise.vue?vue&type=template&id=651edb46&scoped=true"
import script from "./Personalise.vue?vue&type=script&lang=js"
export * from "./Personalise.vue?vue&type=script&lang=js"
import style0 from "./Personalise.vue?vue&type=style&index=0&id=651edb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651edb46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputCurrency: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/InputCurrency.vue').default,BasketModal: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/BasketModal.vue').default})
